(() => {
  const root = document.querySelector('[data-halloween]');
  const stage = document.querySelector('[data-halloween-stage]');
  if (!root || !stage) return;

  const params = new URLSearchParams(window.location.search);
  if (params.get('halloween') === '0') {
    root.remove();
    stage.remove();
    document.getElementById('gt-halloween-icon')?.remove();
    return;
  }

  const pumpkinTemplate = document.getElementById('gt-pumpkin-template');
  const batTemplate = document.getElementById('gt-bat-template');
  if (!pumpkinTemplate || !batTemplate) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let pumpkin = null;
  let hoverTimer = 0;

  const place = () => {
    const header = document.querySelector('.header');
    if (!header || !pumpkin) return;

    const logo = header.querySelector('.header__logo');
    const compact = window.matchMedia('(max-width: 1023px)').matches;
    const size = compact ? 64 : 76;
    const headerBox = header.getBoundingClientRect();
    pumpkin.style.width = `${size}px`;

    let left = 16;
    if (logo) {
      const logoBox = logo.getBoundingClientRect();
      left = compact
        ? logoBox.left - headerBox.left - size - 14
        : logoBox.right - headerBox.left + 12;
    }

    const controls = [...header.querySelectorAll('.header__icons a, .header__icons button')]
      .map((element) => element.getBoundingClientRect())
      .filter((rect) => rect.width > 8 && rect.height > 8);

    controls.forEach((rect) => {
      const pumpkinLeft = headerBox.left + left;
      const pumpkinRight = pumpkinLeft + size;
      const overlaps = pumpkinRight > rect.left + 2 && pumpkinLeft < rect.right - 2;
      if (!overlaps) return;

      const shiftLeft = rect.left - headerBox.left - size - 10;
      left = shiftLeft > 8 ? shiftLeft : rect.right - headerBox.left + 10;
    });

    const navigation = header.querySelector('.header__navigation');
    if (navigation && getComputedStyle(navigation).display !== 'none') {
      const navLeft = navigation.getBoundingClientRect().left - headerBox.left;
      if (left + size > navLeft - 8) left = navLeft - size - 8;
    }

    const height = size * (693 / 520);
    pumpkin.style.left = `${Math.round(Math.max(8, left))}px`;
    pumpkin.style.top = `${Math.round(Math.max(4, (header.clientHeight - height) / 2))}px`;
    pumpkin.classList.add('is-placed');
  };

  const mount = () => {
    const header = document.querySelector('.header');
    if (!header) return;

    pumpkin = header.querySelector('.gt-pumpkin');
    if (!pumpkin) {
      pumpkin = pumpkinTemplate.content.firstElementChild.cloneNode(true);
      header.appendChild(pumpkin);
    }

    place();
  };

  const spawnBat = (serial, delay) => {
    const mouth = pumpkin && pumpkin.querySelector('.gt-pumpkin__mouth');
    if (!mouth || stage.childElementCount > 7) return;

    const rect = mouth.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight - 8) return;

    const header = document.querySelector('.header');
    const headerBox = header ? header.getBoundingClientRect() : null;
    const pumpkinBox = pumpkin.getBoundingClientRect();
    const bat = batTemplate.content.firstElementChild.cloneNode(true);
    const aspect = 85 / 223;
    const dir = serial % 2 === 0 ? 1 : -1;
    const phase = serial * 1.05;
    const cx = pumpkinBox.left + pumpkinBox.width / 2;
    const cy = headerBox ? headerBox.top + headerBox.height / 2 : pumpkinBox.top + pumpkinBox.height * 0.5;
    let leftBound = 8;
    let rightBound = window.innerWidth - 8;
    document.querySelectorAll('.header__logo, .header__heading, .header__navigation, .header__icons a, .header__icons button').forEach((node) => {
      const box = node.getBoundingClientRect();
      if (box.width < 8 || box.height < 8) return;
      if (box.left < cx && box.right > cx) return;
      if (box.right <= cx) leftBound = Math.max(leftBound, box.right + 8);
      else if (box.left >= cx) rightBound = Math.min(rightBound, box.left - 8);
    });
    const roomLeft = Math.max(28, cx - leftBound);
    const roomRight = Math.max(28, rightBound - cx);
    const room = Math.min(roomLeft, roomRight);
    const open = Math.max(roomLeft, roomRight);
    const size = Math.round(Math.max(46, Math.min(76, room * 1.35, open * 0.62)));
    const half = size / 2;
    const rxLeft = Math.max(14, Math.min(108, roomLeft - half - 6));
    const rxRight = Math.max(14, Math.min(108, roomRight - half - 6));
    const rx = (rxLeft + rxRight) / 2;
    const orbitShift = (rxRight - rxLeft) / 2;
    const maxRy = headerBox ? Math.max(18, (headerBox.height - size * aspect) / 2 - 8) : 22;
    const ry = maxRy * (0.88 + Math.random() * 0.12);
    const originX = cx - size / 2;
    const originY = cy - size * aspect * 0.55;

    bat.style.width = `${size}px`;
    bat.style.left = `${originX}px`;
    bat.style.top = `${originY}px`;
    bat.style.setProperty('--gt-flap', `${0.28 + Math.random() * 0.14}s`);
    stage.appendChild(bat);

    const steps = 28;
    const frames = [];
    for (let step = 0; step <= steps; step += 1) {
      const progress = step / steps;
      const angle = Math.PI / 2 + dir * (phase + progress * Math.PI * 2);
      const grow = Math.min(1, progress / 0.16);
      const bank = Math.cos(angle) * dir * 14;
      const x = cx + orbitShift * grow + Math.cos(angle) * rx * grow - size / 2;
      const y = cy + Math.sin(angle) * ry * grow - size * aspect * 0.55;
      let opacity = 1;
      if (progress < 0.05) opacity = progress / 0.05;
      else if (progress > 0.9) opacity = (1 - progress) / 0.1;
      frames.push({
        transform: `translate3d(${x - originX}px, ${y - originY}px, 0) rotate(${bank}deg) scale(${0.42 + grow * 0.58})`,
        opacity,
        offset: progress
      });
    }

    const animation = bat.animate(frames, {
      duration: 3200 + Math.random() * 600,
      delay,
      easing: 'linear',
      fill: 'forwards'
    });

    animation.onfinish = () => bat.remove();
  };

  let batSerial = 0;

  const release = (count) => {
    if (reducedMotion || !pumpkin || document.hidden) return;
    for (let index = 0; index < count; index += 1) {
      spawnBat(batSerial, index * 140);
      batSerial += 1;
    }
  };

  const stopHover = () => {
    window.clearInterval(hoverTimer);
    hoverTimer = 0;
  };

  const bind = () => {
    if (!pumpkin || pumpkin.dataset.bound === 'true') return;
    pumpkin.dataset.bound = 'true';

    pumpkin.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      release(3);
      stopHover();
      hoverTimer = window.setInterval(() => release(1), 480);
    });

    pumpkin.addEventListener('pointerleave', stopHover);
    pumpkin.addEventListener('pointercancel', stopHover);

    pumpkin.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch') return;
      release(4);
    });

    pumpkin.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      release(3);
    });
  };

  const mountAndBind = () => {
    mount();
    bind();
  };

  mountAndBind();
  window.addEventListener('resize', place, { passive: true });
  window.addEventListener('scroll', place, { passive: true });

  const header = document.querySelector('.header');
  if (header && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(place);
    observer.observe(header);
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(mountAndBind, 50);
    window.setTimeout(mountExtras, 50);
  });

  const mountFooter = () => {
    const scene = document.querySelector('[data-halloween-footer]');
    const footer = document.querySelector('footer.footer');
    const section = footer && footer.closest('.section');
    if (!scene || !section) return;
    if (scene.parentElement !== section) section.insertBefore(scene, section.firstChild);
    scene.hidden = false;

    const art = scene.querySelector('.gt-footer-scene__art');
    const glow = scene.querySelector('.gt-footer-scene__glow');
    const placeGlow = () => {
      if (!art || !glow) return;
      const width = art.offsetWidth;
      const height = art.offsetHeight;
      if (!width || !height) return;
      glow.style.left = `${art.offsetLeft}px`;
      glow.style.top = `${art.offsetTop}px`;
      glow.style.width = `${width}px`;
      glow.style.height = `${height}px`;
    };

    if (art && !art.complete) art.addEventListener('load', placeGlow, { once: true });
    placeGlow();
    window.addEventListener('resize', placeGlow, { passive: true });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(placeGlow);
      observer.observe(scene);
      if (art) observer.observe(art);
    }
  };

  const mountLostPage = () => {
    if (!document.body.classList.contains('template-404')) return;
    const heading = document.querySelector('.template-404 h1.heading');
    const wrap = heading && heading.closest('.title-wrapper');
    if (heading) heading.textContent = 'This page burned down';
    if (!wrap || reducedMotion || wrap.querySelector('.gt-bat--lost')) return;

    const bat = batTemplate.content.firstElementChild.cloneNode(true);
    bat.classList.add('gt-bat--lost');
    const size = 92;
    bat.style.width = `${size}px`;
    bat.style.left = '50%';
    bat.style.top = '0px';
    wrap.appendChild(bat);

    const rx = Math.max(120, Math.min(240, wrap.clientWidth * 0.34));
    const ry = 20;
    const aspect = 85 / 223;
    const steps = 28;
    const frames = [];
    for (let step = 0; step <= steps; step += 1) {
      const progress = step / steps;
      const angle = -Math.PI / 2 + progress * Math.PI * 2;
      const x = Math.cos(angle) * rx - size / 2;
      const y = Math.sin(angle) * ry - size * aspect - 10;
      const bank = Math.cos(angle) * 12;
      frames.push({
        transform: `translate(${x}px, ${y}px) rotate(${bank}deg)`,
        offset: progress
      });
    }

    bat.animate(frames, {
      duration: 6800,
      iterations: Infinity,
      easing: 'linear'
    });
  };

  const holiday = {
    id: 'halloween',
    rises: [
      { page: 'template-index', target: '.slideshow', outside: true, bottom: '8%', first: 1400, gap: 3400, spread: 2200, burst: true },
      { page: 'template-product', target: '.product__gallery .slider', outside: true, bottom: '0px', first: 2400, gap: 6200, spread: 2800, burst: false }
    ],
    cross: { page: 'template-collection', target: '.card-grid', first: 4000, every: 20000 }
  };

  const mountRise = (spec) => {
    if (reducedMotion || !document.body.classList.contains(spec.page)) return;
    const target = document.querySelector(spec.target);
    const host = spec.outside ? target && target.parentElement : target;
    if (!target || !host || host.querySelector('.gt-holiday-rise')) return;

    const layer = document.createElement('div');
    layer.className = 'gt-holiday-rise';
    layer.dataset.holidayEffect = 'rise';
    if (spec.outside) host.insertBefore(layer, target.nextSibling);
    else host.appendChild(layer);

    const spawn = () => {
      if (!layer.isConnected || layer.childElementCount > 5) return;
      const spark = document.createElement('span');
      spark.className = 'gt-holiday-spark';
      spark.style.left = `${8 + Math.random() * 84}%`;
      spark.style.bottom = spec.bottom;
      layer.appendChild(spark);
      const lift = (layer.clientHeight || 420) * (0.45 + Math.random() * 0.25);
      const drift = (Math.random() - 0.5) * 36;
      const animation = spark.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 0 },
        { transform: `translate(${drift * 0.35}px, ${-lift * 0.25}px) scale(1)`, opacity: 0.95, offset: 0.16 },
        { transform: `translate(${drift}px, ${-lift}px) scale(0.35)`, opacity: 0 }
      ], { duration: 1700 + Math.random() * 800, easing: 'ease-out' });
      animation.onfinish = () => spark.remove();
    };

    const tick = () => {
      spawn();
      if (spec.burst && Math.random() < 0.35) window.setTimeout(spawn, 160);
      window.setTimeout(tick, spec.gap + Math.random() * spec.spread);
    };
    window.setTimeout(tick, spec.first);
  };

  const mountMenu = () => {
    const nav = document.querySelector('#MenuDrawer nav');
    const photo = pumpkinTemplate.content.querySelector('.gt-pumpkin__photo');
    if (!nav || !photo || nav.querySelector('.gt-menu-pumpkin')) return;

    const wrap = document.createElement('span');
    wrap.className = 'gt-menu-pumpkin';
    wrap.setAttribute('aria-hidden', 'true');
    const img = document.createElement('img');
    img.src = photo.getAttribute('src');
    img.alt = '';
    img.width = 58;
    img.height = 77;
    const glow = document.createElement('span');
    glow.className = 'gt-menu-pumpkin__glow';
    wrap.append(img, glow);
    nav.appendChild(wrap);
  };

  const mountCross = () => {
    if (reducedMotion || !document.body.classList.contains(holiday.cross.page) || !batTemplate) return;
    const target = document.querySelector(holiday.cross.target);
    if (!target) return;

    const fly = () => {
      if (!target.isConnected || target.querySelector('.gt-holiday-cross')) return;
      const bat = batTemplate.content.firstElementChild.cloneNode(true);
      bat.classList.add('gt-holiday-cross');
      const size = 70;
      bat.style.width = `${size}px`;
      target.appendChild(bat);
      const width = target.clientWidth;
      const y = Math.max(20, target.clientHeight * (0.22 + Math.random() * 0.4));
      const steps = 18;
      const frames = [];
      for (let step = 0; step <= steps; step += 1) {
        const progress = step / steps;
        const x = -size + (width + size * 1.6) * progress;
        const wave = Math.sin(progress * Math.PI * 2) * 16;
        frames.push({
          transform: `translate(${x}px, ${y + wave}px) rotate(${Math.sin(progress * Math.PI) * 10}deg)`,
          opacity: progress < 0.06 || progress > 0.94 ? 0 : 1,
          offset: progress
        });
      }
      const animation = bat.animate(frames, { duration: 5400, easing: 'linear' });
      animation.onfinish = () => bat.remove();
    };

    window.setTimeout(fly, holiday.cross.first);
    window.setInterval(fly, holiday.cross.every);
  };

  const mountExtras = () => {
    mountFooter();
    mountLostPage();
    holiday.rises.forEach(mountRise);
    mountCross();
    mountMenu();
  };

  mountExtras();
})();
